<template>
  <div
    class="column flex mt-5 registration-padding"
    :class="{ mobile: $vuetify.breakpoint.smAndDown }"
  >
    <div
      v-loading="loading"
      class="column flex relative mr-2"
      element-loading-text="Carregando minhas equipes..."
      style="width: 840px"
    >
      <TeamCard
        v-for="team in teams"
        :key="team._id"
        :arrow="true"
        :team="team"
        class="mb-3"
        @click.native="selectTeam(team)"
      />
    </div>
  </div>
</template>

<script>
import Team from "@/services/Team";

import TeamCard from "@/components/Teams/Card";
import _ from "lodash";

export default {
  name: "Team",

  components: {
    TeamCard,
  },

  props: {},
  data() {
    return {
      loading: false,
      teams: [],
    };
  },

  computed: {},

  created() {
    this.fetchTeams();
  },

  methods: {
    selectTeam(team) {
      if (!_.get(team, "_id")) {
        return;
      }

      this.$emit("selectedTeam", team);
    },

    fetchTeams() {
      this.loading = true;

      Team.list().then(
        (res) => {
          this.loading = false;
          this.teams = res.data;
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration/Steps/Team.vue